import { createContext } from 'react';
import { IUsers } from 'types';

export type TUsersSortBy = '' | 'NameA-Z' | 'NameZ-A' | 'RoleA-Z' | 'RoleZ-A';
export type TUsersCountOfItems = '12' | '24' | '48';
export type TTypeOfModalWindow = null | 'toConfirmDeleteItem' | 'success' | 'error';
export interface IFilterValues {
	searchString: string;
	IDSelectedRole: Nullable<string>;
	sortBy: TUsersSortBy;
	countOfItems: TUsersCountOfItems;
	currentPage: number;
}

export interface IUsersState {
	users: IUsers;
	searchString: string;
	IDSelectedRole: Nullable<string>;
	sortBy: TUsersSortBy;
	countOfItems: TUsersCountOfItems;
	currentPage: number;
	IDForDeletion: string;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const usersInitialState: IUsersState = {
	users: { usersCount: 0, users: [] },
	searchString: '',
	IDSelectedRole: null,
	sortBy: '',
	countOfItems: '12',
	currentPage: 1,
	IDForDeletion: '',
	typeOfModalWindow: null,
};

export interface IUsersContext extends IUsersState {
	deleteSelectedItem(): void;
	changeSearchString(value: string): void;
	setIDRole(value: Nullable<string>): void;
	resetSelectedControls(): void;
	setSortBy(sortBy: TUsersSortBy): void;
	setCountOfItems(count: TUsersCountOfItems): void;
	changeCurrentPage(page: number): void;
	setIDForDeletion(value: Nullable<string>): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	setFiltersFromQueryString(value: IFilterValues): void;
}

export const UsersContext = createContext<IUsersContext>({
	deleteSelectedItem: () => undefined,
	changeSearchString: () => undefined,
	setIDRole: () => undefined,
	resetSelectedControls: () => undefined,
	setSortBy: () => undefined,
	setCountOfItems: () => undefined,
	changeCurrentPage: () => undefined,
	setIDForDeletion: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setFiltersFromQueryString: () => undefined,
	...usersInitialState,
});
